const multiSelect = 'multiSelect';
const number = 'number';
const singleSelect = 'singleSelect';
const string = 'string';
const tags = 'tags';
const boolean = 'boolean';
const date = 'date';

const input = 'input';
const mask = 'mask';
const select = 'select';
const checkbox = 'switch';
const tagSelect = 'tagSelect';
const datePicker = 'datePicker';
const textEditor = 'textEditor';
const giftMessageEditor = 'giftMessageEditor';

const componentTypes = [input, mask, select, checkbox, datePicker, tagSelect];

const columnTypes = [
  multiSelect,
  number,
  singleSelect,
  tags,
  string,
  boolean,
  date,
  textEditor,
  giftMessageEditor,
  mask
];

export {
  boolean,
  checkbox,
  columnTypes,
  componentTypes,
  date,
  datePicker,
  giftMessageEditor,
  input,
  mask,
  multiSelect,
  number,
  select,
  singleSelect,
  string,
  tagSelect,
  tags,
  textEditor
};
